/**
 * Svelte attachments for css-motion
 */

import type { Attachment } from 'svelte/attachments';
import { observeElement, IntersectionObserverOptions } from '../core';

/**
 * Attachment that adds "in-view" class when element enters viewport
 *
 * @example
 * ```svelte
 * <div class="css-motion" {@attach observeOnView}>...</div>
 * ```
 */
export const observeOnView =
  (options?: IntersectionObserverOptions): Attachment<HTMLElement> =>
  element => {
    return observeElement(element, options);
  };
